import Group from './Group';
import UserMetaExternalAmsData from './UserMetaExternalAmsData';

export default class UserMetaData {

	public UUID: string | null = null;
	public userID: number| null = null;
	public username: string | null = null;
	public firstName: string | null = null;
	public lastName: string | null = null;
	public producerId: number | null = null;
	public isAdmin: boolean | null = null;
	public isUnderwriter: boolean | null = null;
	public isProducerAdmin: boolean | null = null;
	public isNPBEAdmin: boolean | null = null;
	public impersonatorUserMetaData: UserMetaData | null = null;
	public userGroups: Group[] = [];
	public externalAms: UserMetaExternalAmsData | null = null;

	public constructor() {

	}
};